import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { Invoice, UpdateSAPCodeInvoicePayload } from 'contracts/Invoice';

const { Types, Creators } = createActions(
  {
    request: ['payload', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'UPDATE_SAPCODE_INVOICE_',
  }
);

export interface UpdateSAPCodeInvoiceState {
  data: Invoice[];
  loading: boolean;
  errorMessage: string | null;
}

export interface UpdateSAPCodeInvoiceRequestAction {
  payload: UpdateSAPCodeInvoicePayload;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Invoice[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: UpdateSAPCodeInvoiceState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: UpdateSAPCodeInvoiceState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: UpdateSAPCodeInvoiceState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: UpdateSAPCodeInvoiceState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: UpdateSAPCodeInvoiceState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const updateSAPCodeInvoice = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const UpdateSAPCodeInvoiceTypes = Types;
export const UpdateSAPCodeInvoiceActions = Creators;
